import * as React from "react";
import styled from "styled-components";
import Logs from "pages/DelegatedSearchPage";
import { Modal } from "components/bootstrap";
const LogsContainer = styled.div`
  footer,
  #main-row > div:first-of-type,
  .react-grid-item:first-child {
    display: none;
  }
  .react-grid-item {
    top: 0px !important;
  }
  .react-grid-layout {
    height: 630px !important;
  }
`;
const LogsModal = ({ show, onCancel }) => /* @__PURE__ */ React.createElement(Modal, { show, bsSize: "xlarge", onHide: onCancel }, /* @__PURE__ */ React.createElement(Modal.Header, null, /* @__PURE__ */ React.createElement(Modal.Title, null, "Add Logs")), /* @__PURE__ */ React.createElement(Modal.Body, null, /* @__PURE__ */ React.createElement(LogsContainer, null, /* @__PURE__ */ React.createElement(Logs, null))));
export default LogsModal;
